export default class extends Controller {
  static targets = ["head", "body"];

  connect() {
    App.Helpers.xhrContentHandler(this.headTarget, this.linkSelector, this.element, false, this.showSpinner.bind(this));
  }

  showSpinner() {
    this.bodyTarget.innerHTML = `<div style="height: ${this.bodyHeight}px; padding-top: ${this.paddingHeight}px">${App.spinner()}</div>`;
  }

  //
  // GETTERS
  //

  get linkSelector() {
    return '[data-link="sort-column-remote"]';
  }

  get bodyHeight() {
    return this.bodyTarget.offsetHeight;
  }

  get paddingHeight() {
    return (this.bodyHeight / 2) - 20;
  }
};



// WEBPACK FOOTER //
// ./app/javascript/stimulusControllers/financials/transactions-card-table-controller.js